import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/regions/form'
import { api, actionCreators } from 'store/modules/regions'

const metadata = {
  icon: 'globe',
  page: 'regions',
  dialogSize: dialogSizes.XL
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
